import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { CardComponent } from '../../components/card/card.component';

@Component({
  selector: 'vectronic-confirm-delete',
  templateUrl: './confirm-delete.component.html',
  styleUrls: ['./confirm-delete.component.scss'],
  imports: [CardComponent, MatDialogContent, MatDialogActions, MatButton, MatIcon],
})
export class ConfirmDeleteComponent {
  result: boolean;
  dialogRef = inject(MatDialogRef<ConfirmDeleteComponent>);
  data: { title: string; bodyText: string } = inject(MAT_DIALOG_DATA);

  onDelete() {
    this.dialogRef.close(true);
  }
}
